module.exports = __webpack_public_path__ + "static/media/toyota_ps_logo.10bdc3d4.png";